<template>
  <div>
    <div v-if="dataLoaded" :class="hideHome">
      <router-view></router-view>
      <!-- <Covid /> -->
      <Header :class="{ sticky: isNotInHp }" :parentLang="langData" v-on:scrollMeTo="scrollMeToRef($event)" />
      <SectionIntro ref="intro" />
      <SectionLoStudio ref="studio" />
      <SectionISoci ref="soci" />
      <Banner2  class="d-none d-lg-block"/>
      <SectionCollaboratori ref="collaboratori" />
      <SectionAttivita ref="sedi" />
      <SectionNewtork ref="network" />
      <SectionLoStudioLegale class="d-none d-lg-block"  ref="studio-legale" />
      <!-- <SectionNews ref="news" />  -->
      <SectionQualita ref="qualita" :langData="this.langData" />
      <SectionContatti ref="contatti" /> 
      <TheFooter/>
    </div>
    <div v-else>
      <LoadingScreen />
    </div>
  </div>
</template>

<script>
import AOS from 'aos';

AOS.init({
    once: true
});

import CookieBanner from '@/components/CookieBanner.vue'

import Header from '@/components/Header.vue'
import TheFooter from '@/components/TheFooter.vue'

import Banner2 from '@/components/Banner2.vue' 
import SectionIntro from '@/components/SectionIntro.vue'
import SectionLoStudio from '@/components/SectionLoStudio.vue'
import SectionISoci from '@/components/SectionISoci.vue'
import SectionLoStudioLegale from '@/components/SectionLoStudioLegale.vue' 
import SectionCollaboratori from '@/components/SectionCollaboratori.vue' 
import SectionAttivita from '@/components/SectionAttivita.vue' 
import SectionNewtork from '@/components/SectionNewtork.vue' 
import SectionNews from '@/components/SectionNews.vue' 
import SectionQualita from '@/components/SectionQualita.vue' 
import SectionContatti from '@/components/SectionContatti.vue' 
import LoadingScreen from '@/components/LoadingScreen.vue' 
import CovidBanner from '@/components/CovidBanner.vue' 


export default {
  name: 'Home',
  components: {
    CookieBanner,
     Header,
     TheFooter,
     SectionIntro,
     SectionLoStudio,
     SectionISoci,
     SectionLoStudioLegale,
     SectionCollaboratori,
     SectionAttivita,
     SectionNewtork,
     SectionNews,
     SectionQualita,
     SectionContatti,
     LoadingScreen,
     Banner2,
     CovidBanner
    },
  data: function() {
    return {
      langData:"",
      dataNodePages:'',
      dataLoaded:false,
      pageName:""
    }
  },
  methods:{
    scrollMeToRef(ref){
      var element = this.$refs[ref];
      var top = element.$el.offsetTop;
      window.scrollTo(0, top);

      console.log('scrollMeToRef');
    },
    emptyData(){
      this.dataNodePages = "";
    },
    loadDataApi(){
      console.log('this.langData',this.langData);
      this.emptyData();
      this.dataLoaded = false
      

      fetch("https://ptnlex-api-prod.interfase.tv/"+this.langData+"/jsonapi", {method: "GET", mode: 'cors'})
        .then(response=>{
          return response.json()
        })
        .then(json=>{
          this.dataNodePages = json.links["node--page"].href
          this.dataLoaded = true
        })
        .catch(function(error) {  
          console.log('Request failed', error)  
        });
    }
  },
  computed:{
    isNotInHp(){
      if( this.$route.name != "Home" ) {
        return true
      } else {
        return false
      }
    },
    changePage(){
      console.log('changePage',this.$route);
      this.pageName = this.$route.params.name
    },
    hideHome(){
      console.log(this.$route.name);
      if( this.$route.name == "privacy" ) {
        return "showPrivacy"
      } else if( this.$route.name == "cookie" ){
        return "showCookie"
      }
       else if( this.$route.name == "emergenza-covid" ){
        return "showCovid"
      }
    }
  },  
  watch: {
    langData() {
      //console.log('watch langData');
      this.loadDataApi()
    },
    $route(to,from){

      if(this.$route.params.lang == "en"){
        this.langData = "en"
      } else {
        this.langData = "it"
      }

    }, 
  },
  created(){
    this.langData = this.$route.params.lang
    this.loadDataApi()

    window.addEventListener('scroll', () => {
      document.body.style.setProperty('--scroll',window.pageYOffset / (document.body.offsetHeight - window.innerHeight));
    }, false);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.showCookie{
  &>div{
    display: none;
  }
  &>div.cookie{
    display: block;
  }
}
.showPrivacy{
  &>div{
    display: none;
  }
  &>div.privacy{
    display: block;
  }
}

.showCovid{
  &>div{
    display: none;
  }
  &>div.covid{
    display: block;
  }
}
</style>
